import React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { addressObject, getSelectLabel, lang, userFullName } from 'src/helpers';
import moment from 'moment/moment';
import { Avatar } from 'src/components/basic';
import constants from 'src/constants';

export const PatientProfileCard = React.memo(({ patient }) => (
  <>
    <Avatar
      text={userFullName(patient)}
      width={'100%'}
      height={400}
      square={true}
      image={patient.avatar}
    />
    <div className={'mc-flex-15-col'}>
      <div className={'mc-value-620'}>{userFullName(patient)}</div>
    </div>
    <div className={'mc-flex mc-flex-start'}>
      <div className={'mc-flex-col mc-grow'}>
        <div className={'mc-label-416'}>{lang.t('Gender')}</div>
        <div className={'mc-value-518'}>
          {getSelectLabel(constants.general.gender, patient.gender)}
        </div>
      </div>
      <div className={'mc-flex-col mc-grow'}>
        <div className={'mc-label-416'}>{lang.t('Birthday')}</div>
        <div className={'mc-value-518'}>
          {patient.birthday &&
            moment(
              patient.birthday,
              patient.birthday.toString().length === 8 ? 'YYYYMMDD' : ''
            ).format('MMMM DD, YYYY')}
          &nbsp;
        </div>
      </div>
    </div>
    <div className={'mc-flex-col'}>
      <div className={'mc-label-416'}>{lang.t('Phone')}</div>
      <div className={'mc-value-518'}>
        {formatPhoneNumberIntl((patient.phoneNumber || '').toString())}
      </div>
    </div>
    <div className={'mc-flex-col'}>
      <div className={'mc-label-416'}>{lang.t('Address')}</div>
      <div className={'mc-value-518'}>{patient.address}&nbsp;</div>
    </div>
    <div className={'mc-flex-col'}>
      <div className={'mc-label-416'}>{lang.t('City')}</div>
      <div className={'mc-value-518'}>{addressObject(patient).cityName}&nbsp;</div>
    </div>
    <div className={'mc-flex-col'}>
      <div className={'mc-label-416'}>{lang.t('Registration date')}</div>
      <div className={'mc-value-518'}>{moment(patient.created).format('MMMM DD, YYYY')}</div>
    </div>
  </>
));
